"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropZone = exports.useDragProvider = exports.useDragHandler = exports.dragTypes = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
var _DndMouseBackend = _interopRequireDefault(require("../components/DndMouseBackend"));
var _classnames = _interopRequireDefault(require("classnames"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _excluded = ["type", "extraInfo", "enableCustomPreview"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dragTypes = exports.dragTypes = {
  message: 'MESSAGE'
};
var POSITION = {
  x: 0,
  y: 0
};
var ANIMATE_MS = 250;
var DragLayer = function DragLayer(_ref) {
  var layer = _ref.layer;
  var _useState = (0, _react.useState)({
      styles: {},
      shouldHide: true,
      origin: POSITION,
      animateMs: ANIMATE_MS
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useDragLayer = (0, _reactDnd.useDragLayer)(function (monitor) {
      return {
        didDrop: monitor.didDrop(),
        isDragging: monitor.isDragging(),
        clientOffset: monitor.getClientOffset()
      };
    }),
    isDragging = _useDragLayer.isDragging,
    clientOffset = _useDragLayer.clientOffset,
    didDrop = _useDragLayer.didDrop;
  (0, _react.useEffect)(function () {
    var body = document.body;
    if (body) {
      // Prevent to select text while dragging in Safari
      if (state.shouldHide) {
        body.classList.remove('select-none');
      } else {
        body.classList.add('select-none');
      }
    }
  }, [state.shouldHide]);
  (0, _react.useEffect)(function () {
    var animate = window.requestAnimationFrame(function () {
      setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          styles: getLayerStyles(state.origin, clientOffset)
        });
      });
    });
    return function () {
      return window.cancelAnimationFrame(animate);
    };
  }, [clientOffset, state.origin]);
  (0, _react.useEffect)(function () {
    if (isDragging) {
      if (state.shouldHide) {
        setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            shouldHide: false,
            origin: _objectSpread({}, clientOffset)
          });
        });
      }
    } else {
      var timer = setTimeout(function () {
        return setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            shouldHide: true,
            origin: POSITION
          });
        });
      }, state.animateMs);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [isDragging]);
  (0, _react.useEffect)(function () {
    if (didDrop) {
      setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          animateMs: 0
        });
      });
    } else {
      setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          animateMs: ANIMATE_MS
        });
      });
    }
  }, [didDrop]);
  if (state.shouldHide || (0, _isNil["default"])(layer)) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex absolute inset-0 select-none', {
      'cursor-grabbing': isDragging
    }),
    style: {
      zIndex: 9999
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: state.styles
  }, layer));
};
var useDragProvider = exports.useDragProvider = function useDragProvider() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$backend = _ref2.backend,
    backend = _ref2$backend === void 0 ? _DndMouseBackend["default"] : _ref2$backend,
    _ref2$options = _ref2.options,
    options = _ref2$options === void 0 ? {} : _ref2$options,
    dragLayer = _ref2.dragLayer;
  var Provider = (0, _react.useCallback)(function (_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/_react["default"].createElement(_reactDnd.DndProvider, {
      backend: backend,
      options: options
    }, dragLayer && /*#__PURE__*/_react["default"].createElement(DragLayer, {
      layer: dragLayer
    }), children);
  }, [backend, dragLayer]);
  return {
    Provider: Provider
  };
};
var useDragHandler = exports.useDragHandler = function useDragHandler() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    type = _ref4.type,
    extraInfo = _ref4.extraInfo,
    enableCustomPreview = _ref4.enableCustomPreview,
    rest = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
  var _useDrag = (0, _reactDnd.useDrag)(_objectSpread({
      item: {
        type: type,
        extraInfo: extraInfo
      }
    }, rest)),
    _useDrag2 = (0, _slicedToArray2["default"])(_useDrag, 3),
    ref = _useDrag2[1],
    preview = _useDrag2[2];
  (0, _react.useEffect)(function () {
    if (enableCustomPreview) {
      preview((0, _reactDndHtml5Backend.getEmptyImage)(), {
        captureDraggingState: true
      });
    }
  }, [enableCustomPreview]);
  return {
    ref: ref
  };
};
var useDropZone = exports.useDropZone = function useDropZone(_ref5) {
  var acceptType = _ref5.acceptType,
    onDrop = _ref5.onDrop;
  var _useDrop = (0, _reactDnd.useDrop)({
      accept: acceptType,
      drop: onDrop,
      collect: function collect(monitor) {
        return {
          isOver: monitor.isOver()
        };
      }
    }),
    _useDrop2 = (0, _slicedToArray2["default"])(_useDrop, 2),
    isOver = _useDrop2[0].isOver,
    ref = _useDrop2[1];
  return {
    ref: ref,
    isOver: isOver
  };
};
function getLayerStyles(origin, clientOffset) {
  if (!clientOffset) {
    return {
      opacity: 0,
      transform: "translate(".concat(origin.x, "px, ").concat(origin.y, "px)"),
      transition: 'transform 200ms, opacity cubic-bezier(1, .1, 1, .4) 220ms'
    };
  }
  var transform = "translate(".concat(clientOffset.x - 5, "px, ").concat(clientOffset.y - 5, "px)");
  return {
    transform: transform,
    WebkitTransform: transform
  };
}
//# sourceMappingURL=dnd.js.map